import { FC, useEffect, useState } from 'react'

import { Button, ButtonGroup, HStack } from '@chakra-ui/react'
import { ToolbarRotateIcon, ToolbarScaleIcon, ToolbarTranslateIcon } from '@editor/assets/icons'
import { EDITOR_SUB_TOOLS } from '@editor/config/constants'
import { TransformTypes } from '@editor/interfaces/canvas'
import { useAppDispatch, useAppSelector } from '@editor/store/app'
import { isMobile } from 'react-device-detect'

import { setCurrentTransformType } from '../store/editor'
import SubToolbarButton from './components/SubToolbarButton'

const TransformControlsToolbar: FC = () => {
  // Store
  const dispatch = useAppDispatch()
  const message = useAppSelector((state) => state.attentionText.message)
  const allowedTransformControls = useAppSelector((state) => state.editor.allowedTransformControls)
  const currentTransformType = useAppSelector((state) => state.editor.currentTransformType)
  const disableTransformControls = useAppSelector((state) => state.editor.disableTransformControls)

  // States
  const [topOffset, setTopOffset] = useState<string | number>(1)

  /**
   * Adjust top offset when message changes.
   */
  useEffect(() => {
    if (message) {
      const canvas = document.getElementById('canvasBox')
      const ele = document.getElementById('attention-text')
      if (ele && canvas) {
        const canvasRect = canvas.getBoundingClientRect()
        const eleRect = ele.getBoundingClientRect()
        setTopOffset(`${eleRect.bottom - canvasRect.top + 10}px`)
      }
      return
    }

    setTopOffset('10px')
  }, [message, allowedTransformControls, currentTransformType])

  /**
   * Handle reset transforms click.
   */
  const handleResetTransforms = () => {
    document.dispatchEvent(new CustomEvent('transform-controls:reset'))
  }

  if (!allowedTransformControls?.length) return null

  return (
    <HStack
      left={isMobile ? '600px' : '50%'}
      transform="translateX(-50%)"
      overflow="hidden"
      position="absolute"
      gap={4}
      top={topOffset}
    >
      <ButtonGroup attached>
        {!allowedTransformControls ||
          (allowedTransformControls?.includes(TransformTypes.TRANSLATE) && (
            <SubToolbarButton
              icon={<ToolbarTranslateIcon width="1.5em" height="1.5em" />}
              label="移動"
              toolType={EDITOR_SUB_TOOLS.CUBOID.TRANSLATE}
              selected={currentTransformType === TransformTypes.TRANSLATE}
              disabled={disableTransformControls}
              onClick={() => dispatch(setCurrentTransformType(TransformTypes.TRANSLATE))}
            />
          ))}
        {!allowedTransformControls ||
          (allowedTransformControls?.includes(TransformTypes.SCALE) && (
            <SubToolbarButton
              icon={<ToolbarScaleIcon width="1.5em" height="1.5em" />}
              label="サイズ"
              toolType={EDITOR_SUB_TOOLS.CUBOID.SCALE}
              selected={currentTransformType === TransformTypes.SCALE}
              disabled={disableTransformControls}
              onClick={() => dispatch(setCurrentTransformType(TransformTypes.SCALE))}
            />
          ))}
        {!allowedTransformControls ||
          (allowedTransformControls?.includes(TransformTypes.ROTATE) && (
            <SubToolbarButton
              icon={<ToolbarRotateIcon width="1.5em" height="1.5em" />}
              label="回転"
              toolType={EDITOR_SUB_TOOLS.CUBOID.ROTATE}
              selected={currentTransformType === TransformTypes.ROTATE}
              disabled={disableTransformControls}
              onClick={() => dispatch(setCurrentTransformType(TransformTypes.ROTATE))}
            />
          ))}
      </ButtonGroup>
      <Button
        // TODO:variant="editorGhost"
        lineHeight="1.5rem"
        size="md"
        onClick={handleResetTransforms}
        disabled={disableTransformControls}
      >
        リセット
      </Button>
    </HStack>
  )
}

export default TransformControlsToolbar
